<template>
  <!-- Page Introduction Wrapper -->
  <div class="page-style-a">
    <div class="container">
      <div class="page-intro">
        <h2>Account</h2>
        <ul class="bread-crumb">
          <li class="has-separator">
            <i class="ion ion-md-home"></i>
            <router-link :to="{name : 'Home'}">Home</router-link>
          </li>
          <li class="is-marked">
            <a href="account.html">Account</a>
          </li>
        </ul>
      </div>
    </div>
  </div>
  <!-- Page Introduction Wrapper /- -->
  <!-- Account-Page -->
  <div class="page-account u-s-p-t-80">
    <div class="container login_container">
      <div class="row">
        <!-- Login -->
        <Login />
        <!-- Login /- -->
        <!-- Register -->
        <Register />
        <!-- Register /- -->
      </div>
    </div>
  </div>
  <!-- Account-Page /- -->
  <Footer />
</template>

<script>
import Login from "../components/Auth/Login.vue";
import Register from "../components/Auth/Register.vue";
import Footer from "../components/Bottom/Footer.vue";
export default {
  components: { Login, Register, Footer },
  mounted() {
    console.log("Auth Vue Mounted");
    const el = document.getElementsByClassName("page-style-a")[0]
    this.$smoothScroll({
      scrollTo: el, // scrollTo is also allowed to be number
    })
  },
};
</script>

<style>
</style>